import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  return (
    <section className="py-16 md:py-20 lg:py-24 bg-gradient-to-br from-primary via-secondary to-accent">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">
            Ready to Experience True Offline Freedom?
          </h2>
          
          <p className="font-body text-base md:text-lg lg:text-xl text-white/90 mb-8 md:mb-10 lg:mb-12">
            Join thousands of Nigerian retailers who trust Cultaz Desktop POS for reliable, internet-independent retail management. Start your free 30-day trial today.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6 mb-12 md:mb-16">
            <Button
              asChild
              variant="secondary"
              size="lg"
              iconName="Download"
              iconPosition="left"
              className="w-full sm:w-auto bg-white text-primary hover:bg-white/90"
            >
              <Link to="/downloads">Download Free Trial</Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              iconName="Phone"
              iconPosition="left"
              className="w-full sm:w-auto border-white text-white hover:bg-white/10"
            >
              <Link to="/support">Schedule Demo Call</Link>
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="flex flex-col items-center p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
              <Icon name="Users" size={32} color="white" strokeWidth={2} className="mb-3" />
              <div className="font-heading text-3xl md:text-4xl font-bold text-white mb-2">5,000+</div>
              <div className="font-body text-sm md:text-base text-white/80">Active Users</div>
            </div>

            <div className="flex flex-col items-center p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
              <Icon name="Store" size={32} color="white" strokeWidth={2} className="mb-3" />
              <div className="font-heading text-3xl md:text-4xl font-bold text-white mb-2">2,500+</div>
              <div className="font-body text-sm md:text-base text-white/80">Retail Stores</div>
            </div>

            <div className="flex flex-col items-center p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
              <Icon name="Star" size={32} color="white" strokeWidth={2} className="mb-3" />
              <div className="font-heading text-3xl md:text-4xl font-bold text-white mb-2">4.8/5</div>
              <div className="font-body text-sm md:text-base text-white/80">Customer Rating</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;